/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: Tournament.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  19.01.23 3:45 pm.
 * Last modified: 19.01.23 3:45 pm.
 *
 * More information at: https://egt-digital.com/
 *
 * Tournament component displays on all sections containing the word 'tournament'(case insensitive)
 * in it. It accept the section name as parametter. For branded tournament banners (casino specific)
 * the preffered way is to name the sections with underscore separator between the words.
 * Example: secionName: tournament_inbet will try to find branded images inside the BrandedTournamentImagesMap
 * object for inbet. If no such branding exists, then it will use the default images object. It also provides
 * a way for translated banners, as the translated banners should be described in the object. If no
 * translated banner is found for the specific localization code, then the default one will be used.
 */

import React from 'react';
import { getBrandedTournamentImages } from '../api/helpers';
import { useLobbyHost, useSettings } from '../contexts/SettingsContext';

const Tournament = ({ group }: ITournamentProps) => {
    const host = useLobbyHost();
    const [settings] = useSettings();

    const sectioNameAsArray = (group || '')
        .split('_')
        .join(' ')
        .split(' ');
    if (sectioNameAsArray.length > 1) {
        sectioNameAsArray.splice(0, 1);
    }
    const brand = sectioNameAsArray.join('_').toLowerCase();

    const image = getBrandedTournamentImages(brand, settings.languageCode.toLowerCase(), host);

    return (
        <div className="egt_tournament">
            <img src={image} alt="Tournament"></img>
        </div>
    );
};

interface ITournamentProps {
    group?: string;
}

export default Tournament;
